import React from 'react';
import { img_path } from '../../../environment';

interface Image {
  className?: string;
  src?: string;
  source?: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
  style?: React.CSSProperties; // ✅ Add this line to allow style props
}

const ImageWithBasePath: React.FC<Image> = (props) => {
  const fullSrc = `${img_path}${props.src}`;
  const fullSource = props.source ? props.source : fullSrc;

  return (
    <img
      className={props.className}
      src={fullSource}
      height={props.height}
      width={props.width}
      alt={props.alt}
      id={props.id}
      style={props.style} // ✅ Use the style prop here
    />
  );
};

export default ImageWithBasePath;
